import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-smart-dialog-steps',
    templateUrl: './smart-dialog-steps.component.html',
    styleUrls: ['./smart-dialog-steps.component.scss']
})
export class SmartDialogStepsComponent implements OnInit {
    @Input() stepLabels: { [key: number]: string };
    @Input() currentStep: number;

    lastStepIndex = -1;

    ngOnInit(): void {
        this.lastStepIndex = Object.keys(this.stepLabels).length - 1;
    }
}
